module.exports = __webpack_public_path__ + "img/pie_chart.d9b245bb.svg";